// DEPENDENCIES
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";
import * as _ from 'lodash';
// ICONS
// COMPONENTS
import { Spinner } from "react-bootstrap";
import { Link } from 'react-router-dom';
import Select from 'react-select'
import { ModalProgressBar } from "../../../../_metronic/_partials/controls";
import MUIDataTable from "mui-datatables";
// CUSTOM COMPONENTS
import * as alert from '../../../../redux/alertSnackBarRedux';
import * as confirmModal from "../../../../redux/confirmModalRedux";
import JobTeamMemberModal from './_partials/JobTeamMemberModal';
import JobCredentialConditionalBlock from './_partials/JobCredentialConditionalBlock';
// SERVICES AND HELPERS
import * as helper from '../../../../helpers/helper';
import * as trainingTypeService from '../../../../services/companyData/trainingTypeService';
import * as trainingSubTypeService from '../../../../services/companyData/trainingSubTypeService'
import * as credentialService from '../../../../services/training/credentialService';
import * as jobCredentialService from '../../../../services/service/jobCredentialService';
import * as jobTeamMemberService from '../../../../services/service/jobTeamMemberService';
import * as jobCredentialAndBlockService from '../../../../services/service/jobCredentialAndBlockService';
import constants from '../../../../constants/constants';
import { saveJob } from "../../../../services/service/jobService";

const initialJobTeamMember = {
    id: 0,
    userId: null,
    jobId: 0,
    role: '',
    isFormLead: false
}

const JobCredentialAndTeamPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, auth, jobInfo } = props;
    const [loading, setLoading] = useState(false);
    const [credentialTypeList, setCredentialTypeList] = useState([]);
    const [selectedCredentialType, setSelectedCredentialType] = useState(null);
    const [credentialSubTypeList, setCredentialSubTypeList] = useState([]);
    const [selectedCredentialSubType, setSelectedCredentialSubType] = useState(null);
    const [credentialList, setCredentialList] = useState([]);
    const [selectedCredential, setSelectedCredential] = useState(null);
    const [jobCredentials, setJobCredentials] = useState([]);
    const [savedJobCredentialAndBlock, setSavedJobCredentialAndBlock] = useState([]);
    const [showTeamMemberModal, setShowTeamMemberModal] = useState(false);
    const [teamMembers, setTeamMembers] = useState([]);
    const [teamMemberSelectedId, setTeamMemberSelectedId] = useState(0);
    const [isEditable, setIsEditable] = useState(true);
    const [isAuthorizedToEdit, setIsAuthorizedToEdit] = useState([auth.isAdmin, auth.isProjectManager].includes(true));

    const { jobId } = useParams();

    useEffect(() => {
        setLoading(true);
        fetchTrainingType().then(trainingTypes => {
            jobCredentialService.getJobCredentials(jobId).then(res => {
                populateSavedCredential(res).then(savedCredentials => {
                    jobCredentialAndBlockService.getJobCredentialAndBlocks(jobId).then(res => {
                        if (res)
                            setSavedJobCredentialAndBlock(res);
                    })
                });
            })
        });
        fetchJobTeamMembers();
    }, []);

    useEffect(() => {
        if (jobInfo.projectNumber) {
            var myRegexp = new RegExp("-([^-]+)-");
            var match = myRegexp.exec(jobInfo.projectNumber);
            if (['0001', '0002', '0003'].includes(match[1]) && !auth.isAdmin) {
                setIsEditable(false)
            }
        }
    }, [jobInfo]);

    const fetchJobTeamMembers = () => {
        jobTeamMemberService.getJobTeamMembers(jobId).then(res => {
            setTeamMembers(res);
        });
    }

    const removeTeamMember = (id) => {
        setProcessing();
        jobTeamMemberService.deleteTeamMember(id).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            fetchJobTeamMembers();
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))
            .finally(() => hideConfirmModal());
    }

    const changeFormLead = (teamMemberId) => {
        jobTeamMemberService.changeFormLead(jobId, teamMemberId).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            fetchJobTeamMembers();
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' }))
        .finally(() => hideConfirmModal());
    }

    const populateSavedCredential = (jobCredentials) => {
        return credentialService.getCredentials(false).then(res => {
            let saveJobCredentials = jobCredentials.map(jobCredential => {
                let savedCredential = res.find(x => x.id == jobCredential.credentialId);
                if (savedCredential) {
                    return {
                        id: jobCredential.id,
                        credentialId: jobCredential.credentialId,
                        type: savedCredential.trainingType ? savedCredential.trainingType : 'No Training Type',
                        subType: (savedCredential.trainingSubType ? savedCredential.trainingSubType : "No SubType"),
                        credential: savedCredential.name,
                        name:
                            `${savedCredential.trainingType ? savedCredential.trainingType : 'No TrainingType'}
                         - ${savedCredential.trainingSubType ? savedCredential.trainingSubType : 'No SubType'} -
                         ${savedCredential.name}`
                    };
                }
                else {
                    return null;
                }
            }).filter(n => n)
            setJobCredentials(saveJobCredentials);

            return saveJobCredentials;
        }).catch(ex => console.log(ex))
            .finally(() => setLoading(false));
    }

    const fetchTrainingType = () => {
        return trainingTypeService.getTrainingTypes(false).then(res => {
            let options = res.map(x => helper.setToOptionModel(x.name, x.id));
            setCredentialTypeList(options);

            return options;
        }).catch(ex => showAlert({ message: ex.message, variant: 'error' }));
    }

    const fetchTrainingSubType = (trainingTypeId) => {
        return trainingSubTypeService.getTrainingSubTypes(trainingTypeId, false).then(res => {
            let options = res.map(x => helper.setToOptionModel(x.name, x.id));
            options.push(helper.setToOptionModel("No SubType", 0));
            setCredentialSubTypeList(options);

            return options;
        })
    }

    const addCredential = () => {
        let allJobCredentials = [...jobCredentials];
        let credentialToSendToApi = [];

        selectedCredential.forEach(credential => {
            if (!jobCredentials.map(x => x.credentialId).includes(credential.value)) {
                allJobCredentials.push({
                    id: '',
                    credentialId: credential.value,
                    type: selectedCredentialType.label,
                    subType: selectedCredentialSubType.label,
                    credential: credential.label,
                    name: selectedCredentialType.label + ' - ' + selectedCredentialSubType.label + ' - ' + credential.label
                });

                credentialToSendToApi.push({ jobId: jobId, credentialId: credential.value });
            }
        });

        jobCredentialService.saveJobCredentials(credentialToSendToApi).then(res => {
            allJobCredentials.forEach(credential => {
                let jobCredential = res.jobCredentials.find(x => x.credentialId == credential.credentialId);
                if (jobCredential) {
                    credential.id = jobCredential.id;
                }
            });

            setJobCredentials(allJobCredentials);
            emptyDropDowns();
            showAlert({ message: res.message, variant: 'success' })
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        })
    }

    const fetchCredential = (typeId, subTypeId) => {
        return credentialService.getCredentialsByTypeAndSubType(typeId, subTypeId).then(res => {
            var options = res.map(x => helper.setToOptionModel(x.name, x.id));
            setCredentialList(options);

            return options;
        })
    }

    const removeCredential = (index, id) => {
        setProcessing();
        jobCredentialService.deleteJobCredential(id, jobId).then(res => {
            showAlert({ message: res.message, variant: 'success' })
            let allJobCredentials = [...jobCredentials];
            allJobCredentials.splice(index, 1);

            setJobCredentials(allJobCredentials);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' })
        }).finally(() => hideConfirmModal());
    }

    const emptyDropDowns = () => {
        setSelectedCredential(null);
        setSelectedCredentialType(null);
        setSelectedCredentialSubType(null);
        setCredentialSubTypeList([]);
        setCredentialList([]);
    }

    const handleCredentialTypeChange = (val) => {
        setSelectedCredentialSubType(null);
        setSelectedCredential(null);
        setSelectedCredentialType(val);
        fetchTrainingSubType(val.value);
    }

    const handleCredentialSubTypeChange = (val) => {
        setSelectedCredential(null);
        setSelectedCredentialSubType(val);
        fetchCredential(selectedCredentialType.value, val.value);
    }

    const credentialColumns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                print: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="flex-container">
                            <button
                                className={`btn btn-danger btn-sm font-weight-bold font-size-sm mr-3`}
                                onClick={() => showConfirmModal({
                                    title: "Delete Credential",
                                    text: "Are you sure you want to remove this credential?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => removeCredential(dataIndex, jobCredentials[dataIndex].id)
                                })}
                            >
                                Remove
                            </button>
                        </div>
                    );
                }
            },
        },
        {
            name: "type",
            label: "Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "subType",
            label: "Sub Type",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "credential",
            label: "Credential",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
    ]

    const userColumns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                print: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="flex-container">
                            <a
                                aria-hidden
                                className={`btn btn-info btn-sm font-weight-bold font-size-sm mr-3`}
                                {...(isAuthorizedToEdit && { href: constants.API_URL + "api/JobTeamMember/ViewTeamMemberCredentialsForJob?jobTeamMemberId=" + teamMembers[dataIndex].id + '&token=' + auth.authToken })}
                                target="_blank"
                            >
                                View
                            </a>
                            {
                                isEditable && isAuthorizedToEdit && !teamMembers[dataIndex].isFormLead && <a
                                    aria-hidden
                                    className={`btn btn-info btn-sm font-weight-bold font-size-sm mr-3`}
                                    onClick={() => showConfirmModal({
                                        title: "Switch Form Lead",
                                        text: "Are you sure you want switch the form lead role to this team member?",
                                        rightBtnText: "Confirm",
                                        btnAction: () => changeFormLead(teamMembers[dataIndex].id)
                                    })}
                                >
                                    Make Form Lead
                                </a>
                            }
                            {isEditable && isAuthorizedToEdit && <button
                                className={`btn btn-danger btn-sm font-weight-bold font-size-sm mr-3`}
                                onClick={() => showConfirmModal({
                                    title: "Remove Team Member",
                                    text: "Are you sure you want to remove this team member from the job?",
                                    rightBtnText: "Confirm",
                                    btnAction: () => removeTeamMember(teamMembers[dataIndex].id)
                                })}
                            >
                                Remove
                            </button>}
                        </div>
                    );
                }
            },
        },
        {
            name: "name",
            label: "Name",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className="circle-badge-container">
                            <p><span style={{ fontSize: '1.1rem' }}>{teamMembers[dataIndex].name}</span> {teamMembers[dataIndex].isFormLead && <span className={`small-badge info ml-3`}>Form Lead</span>}</p>
                        </div>
                    )
                }
            }
        },
        {
            name: "role",
            label: "Role",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        },
        {
            name: "additionalTitle",
            label: "Descriptive Role",
            options: {
                filter: true,
                filterType: 'multiselect',
                sort: true,
            }
        }
    ]

    return (
        <div className="card card-custom" >
            <JobTeamMemberModal
                showTeamMemberModal={showTeamMemberModal}
                setShowTeamMemberModal={setShowTeamMemberModal}
                jobId={jobId}
                showAlert={showAlert}
                fetchJobTeamMembers={fetchJobTeamMembers}
            // jobTeamMember={jobTeamMember}
            />
            {loading && <ModalProgressBar />}
            <div className="card-header py-3">
                <div className="card-title align-items-start flex-column">
                    <h3 className="card-label font-weight-bolder text-dark">
                        {isAuthorizedToEdit ? 'Edit Credential & Team' : 'View Credential & Team'}
                    </h3>
                    <span className="text-muted font-weight-bold fz-xs mt-1">
                        {isAuthorizedToEdit ? 'View and Manage Clients Job Credential & Team Members' : 'View Clients Job Credential & Team Members'}
                    </span>
                </div>
                <div className="card-toolbar">
                    <Link
                        to="/services/jobs"
                        className="btn btn-secondary"
                    >
                        Cancel
                    </Link>
                </div>
            </div>
            <div className="form">
                <div className="card-body">
                    {
                        isEditable && isAuthorizedToEdit &&
                        <>
                            <div className="row">
                                <label className="col-xl-3"></label>
                                <div className="col-lg-9 col-xl-6">
                                    <h5 className="mt-lg-2 mb-6 fz-md fw-700 c-primary">Credential Requirements</h5>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Credential Type
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Select
                                        value={selectedCredentialType}
                                        options={credentialTypeList}
                                        onChange={handleCredentialTypeChange}
                                        name="trainingTypeId"
                                        placeholder="Select Credential Type"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Credential Sub Type
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Select
                                        isDisabled={credentialSubTypeList.length == 0}
                                        value={selectedCredentialSubType}
                                        options={credentialSubTypeList}
                                        onChange={handleCredentialSubTypeChange}
                                        name="trainingTypeId"
                                        placeholder="Select Credential Sub Type"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Credential
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        isDisabled={credentialList.length == 0}
                                        value={selectedCredential}
                                        options={credentialList}
                                        onChange={setSelectedCredential}
                                        name="trainingTypeId"
                                        placeholder="Select Credential"
                                    // menuPlacement="top"
                                    />
                                </div>
                            </div>
                            <div className="form-group row">
                                <div className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                </div>
                                <div className="col-lg-9 col-xl-9 d-flex justify-content-end">
                                    <button onClick={addCredential} disabled={selectedCredential == null} type="button" className="btn btn-success">Add Credential</button>
                                </div>
                            </div>

                            <hr />

                            <div className="form-group row pt-5 mt-5">
                                <div className="col-lg-12 col-xl-12">
                                    <div className="w-100 d-flex align-items-center justify-content-between">
                                        <div className="">
                                            <h3 className="fw-600">Required Job Credential</h3>
                                        </div>
                                        <div className="">
                                        </div>
                                    </div>
                                    <MUIDataTable
                                        data={jobCredentials}
                                        columns={credentialColumns}
                                        options={{
                                            rowsPerPage: 10,
                                            rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                            selectableRows: 'none',
                                            textLabels: {
                                                body: {
                                                    noMatch: loading ?
                                                        <Spinner animation="border" size="lg" variant="info" /> :
                                                        'Sorry, no matching records found.',
                                                },
                                            }
                                        }}

                                    />
                                </div>
                            </div>
                            <JobCredentialConditionalBlock
                                jobId={jobId}
                                availableCredentials={jobCredentials}
                                savedJobCredentialAndBlock={savedJobCredentialAndBlock}
                                setSavedJobCredentialAndBlock={setSavedJobCredentialAndBlock}
                            />
                            <hr />
                        </>
                    }

                    <div className="form-group row pt-5 mt-5">
                        <div className="col-lg-12 col-xl-12">
                            {
                                isEditable && isAuthorizedToEdit &&
                                <div className="w-100 d-flex align-items-center justify-content-between">
                                    <div className="">
                                        <h3 className="fw-600">Team Members</h3>
                                        {teamMembers.length > 0 &&
                                            <a
                                                href={constants.API_URL + "api/JobTeamMember/ViewCombinedTeamMemberCredentialsForJob?jobId=" + jobId + '&token=' + auth.authToken}
                                                target="_blank"
                                                className="btn btn-primary"
                                            >
                                                View Combined Credentials
                                            </a>}
                                    </div>
                                    <div className="">
                                        <button onClick={() => setShowTeamMemberModal(true)} type="button" className="btn btn-success">Add Team Member</button>
                                    </div>
                                </div>
                            }
                            <MUIDataTable
                                data={teamMembers}
                                columns={userColumns}
                                options={{
                                    rowsPerPage: 10,
                                    rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                    selectableRows: 'none',
                                    textLabels: {
                                        body: {
                                            noMatch: loading ?
                                                <Spinner animation="border" size="lg" variant="info" /> :
                                                'Sorry, no matching records found.',
                                        },
                                    }
                                }}

                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, {
    ...alert.actions,
    ...confirmModal.actions
})(JobCredentialAndTeamPage);